import { useQuery } from "@tanstack/react-query";
import { getBolsRequest } from "../requests/bol";

export function useBols({ params }) {
  return useQuery({
    queryKey: ["bol", params],
    queryFn: async () => {
      const res = await getBolsRequest({ params });
      return res.data;
    },
  });
}
